import React from "react";
import "./Footer.css"

export default function Footer() {

    return (
        <>
        
            {/* Footer start */}
            
            <div className="booksmart_footer_container">
                <div className="row m-0">
                    <div className="col-lg-5 p-0">
                        <div className="booksmart_footer_logo">
                            <img src="/assets/images/footer-logo.png"  alt="booksmart-logo" />
                            <p>
                                Everyone’s go-to bookstore for educational and academic books.
                            </p>

                            <p>
                                Copyright © 2022 Booksmart. All Rights Reserved
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-7 p-0 booksmart_footer_links">
                        <div className="d-flex">
                            <div className="col-lg-4 p-0">
                                <div className="booksmart_footer_links_header">
                                    About
                                </div>
                                <div className="booksmart_footer_link">
                                    About Us
                                </div>
                                <div className="booksmart_footer_link">
                                    Terms and Conditions
                                </div>
                                <div className="booksmart_footer_link">
                                    Privacy Policy
                                </div>
                                <div className="booksmart_footer_link">
                                    Sitemap
                                </div>
                            </div>
                            <div className="col-lg-3 p-0">
                                <div className="booksmart_footer_links_header">
                                    Need Help?
                                </div>
                                <div className="booksmart_footer_link">
                                    Refund Policy
                                </div>
                                <div className="booksmart_footer_link">
                                    FAQ
                                </div>
                                <div className="booksmart_footer_link">
                                    Contact Booksmart
                                </div>
                            </div>
                            <div className="col-lg-2 p-0">
                                <div className="booksmart_footer_links_header">
                                    My Account
                                </div>
                                <div className="booksmart_footer_link">
                                    Sign In
                                </div>
                                <div className="booksmart_footer_link">
                                    View Cart
                                </div>
                                <div className="booksmart_footer_link">
                                    My Wish List
                                </div>
                            </div>
                        </div>

                        <div className="booksmart_footer_payment_links">
                            <img src="/assets/images/Amex.png" alt="amex" />
                            <img src="/assets/images/apple-pay.png" alt="apple-pay" />
                            <img src="/assets/images/mastercard.png" alt="mastercard" />
                            <img src="/assets/images/visa.png" alt="visa" />
                            <img src="/assets/images/Paypal.png" alt="Paypal" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer over */}
        </>
    )

}